import {Platform} from 'react-native';
let Storage: any;
if (Platform.OS === 'web') {
  Storage = require('./SecureStore').default;
} else {
  Storage = require('./EncryptedStorage').default;
}

export default Storage;
